<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Job Description Listing</v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on" color="primary" v-if="roles.auth_role">
                          <v-icon>add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Add new</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-expansion-panel>
                        <v-expansion-panel-content class="accent">
                          <template v-slot:header>
                            <div class="subheading">Filter Panel</div>
                          </template>

                          <v-btn color="green" @click="refreshData()">Generate Now</v-btn>

                          <FilterEditor
                            :query.sync="new_filter"
                            :rules="get_filterable_columns"
                            class="accent"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          id="position_table_id"
                          ref="position_table_ref"
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear color="blue" indeterminate>
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.id }}</td>
                            <td class="pa-1">{{ props.item.name }}</td>
                            <td class="pa-1">{{ props.item.desc }}</td>
                            <td class="pa-1">{{ props.item.jd }}</td>
                            <td class="pa-1 blue--text" style="cursor:pointer; font-style: italic;" @click="viewForm_onClick(props.item.jd_form)">{{ props.item.jd_form }}</td>
                            <td class="pa-1">
                              {{
                              convert_2_locale_datetime(props.item.created_date)
                              }}
                            </td>
                            <td class="pa-1">{{ props.item.g_status__value }}</td>
                            <td class="justify-center layout px-0">
                              <v-icon v-if="roles.auth_role"
                                small
                                class="mr-2"
                                color="orange"
                                @click="editRecord_onClick(props.item)"
                              >edit</v-icon>
                              <v-icon v-else
                                small
                                class="mr-2"
                                color="grey"
                              >edit_off</v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- START dialog (edit record) -->
          <v-dialog v-model="dialog.visible" persistent scrollable max-width="600px">
            <v-card>
              <v-card-title class="headline pb-0">{{ dialog.title }} Position Record</v-card-title>

              <v-card-text>
                <v-tabs
                  color="cyan"
                  slider-color="yellow"
                  v-model="tabs.active_tab_id"
                >
                  <v-tab ripple>Position</v-tab>
                  <v-tab ripple v-show="selected.id">Job Grade</v-tab>

                  <v-tab-item class="tab-style">
                    <v-form>
                      <v-container grid-list-md class="pa-0">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              prepend-icon="local_offer"
                              name="name"
                              v-model="selected.name"
                              v-validate="'required|max:100'"
                              :error-messages="errors.first('name')"
                              label="Code (e.g. Sr. Mgr)"
                              type="text"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="selected.desc"
                              name="description"
                              label="Job Description (e.g. Senior Manager)"
                              hint="Max 1000 characters."
                            ></v-textarea>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              v-model="selected.jd"
                              name="jd"
                              label="Doc. Code (e.g. HRJ/CSD/001)"
                              hint="Max 50 characters."
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              v-model="selected.jd_form"
                              name="jd_form"
                              label="Form (e.g. Form 47-001)"
                              hint="Max 50 characters."
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-select
                              :items="status_option"
                              v-model="selected.g_status_id"
                              item-text="value"
                              item-value="id"
                              label="Status"
                              name="status"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 class="text-xs-right">
                            <v-btn color="green darken-1" flat @click="save_onClick()">Save</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-tab-item>

                  <v-tab-item class="tab-style">
                    <v-layout row>
                      <v-flex xs12>
                        <v-combobox
                          :items="dialog.job_grade_list"
                          v-model="job_grade_tab.picked_job_grade"
                          label="Job Grade"
                          clearable
                          item-text="desc"
                          item-value="id"
                        ></v-combobox>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs12>
                        <v-list two-line subheader dense>
                          <v-list-tile v-for="item in job_grade_tab.saved_job_grade" :key="item.job_grade_id" avatar>
                            <v-list-tile-avatar>
                              <v-icon>work</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.job_grade__desc }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ item.job_grade__desc }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                              <v-btn icon ripple @click="delete_job_grade(item)">
                                <v-icon color="grey lighten-1">delete_forever</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>

              <v-card-actions>
                <v-container>
                  <v-layout row wrap>
                    <v-flex class="text-xs-right">
                      <v-btn
                        flat
                        color="orange"
                        @click="
                          dialog.visible = false;
                          tabs.active_tab_id = 0;
                        "
                      >Close</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->

          <!-- START dialog (view form) -->
          <v-dialog v-model="dialog_viewForm.visible" persistent scrollable max-width="1000px">
            <v-card>
              <v-card-title class="headline pb-0">{{ dialog_viewForm.title }}</v-card-title>

              <v-card-text>
                <v-container grid-list-md class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <iframe
                        id="frm_window"
                        frameborder="0"
                        :src="dialog_viewForm.iframe_url"
                        width="100%"
                        :height="dialog_viewForm.height"
                      ></iframe>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange" flat @click="dialog_viewForm.visible = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->

        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>
</template>

<script>
import common from "../../functions/general";
import comm from "../../functions/communication.api";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";
// import PageLayout from "../myDesk/myDesk_layout";
import auth from "../../functions/auth";

export default {
  name: "PositionListingPage",
  components: {
    FilterEditor: FilterEditor,
    // PageLayout: PageLayout
  },
  data() {
    return {
      username: "",
      forms: [],
      roles: {
        roles_list: [],
        auth_role: false
      },
      new_filter: {
        condition: "and",
        rules: []
      },
      tabs: {
        active_tab_id: 0
      },
      table_setting: {
        loading: false,
        rows_per_page_items: [10, 40, 70, 100],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Code",
            class: "pa-1",
            value: "name",
            filterable: true,
            data_type: String
          },
          {
            text: "Job Description",
            class: "pa-1",
            value: "desc",
            filterable: true,
            data_type: String
          },
          {
            text: "Doc. Code",
            class: "pa-1",
            value: "jd",
            filterable: true,
            data_type: String
          },
          {
            text: "Form",
            class: "pa-1",
            value: "jd_form",
            filterable: true,
            data_type: String
          },
          {
            text: "Created DateTime",
            align: "left",
            class: "pa-1",
            value: "created_date",
            filterable: true,
            data_type: Number
          },
          {
            text: "Status",
            align: "left",
            class: "pa-1",
            value: "g_status__value",
            filterable: true,
            data_type: String
          },
          {
            text: "",
            value: "a_actions",
            class: "pa-1",
            filterable: false,
            data_type: Number
          }
        ],
        records: [],
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
          sortBy: "name",
          totalItems: 0
        }
      },
      status_option: [],
      dialog_viewForm: {
        visible: false,
        iframe_url: "",
        title: "",
        height: ""
      },
      dialog: {
        visible: false,
        title: "",
        job_grade_list: []
      },
      job_grade_tab: {
        picked_job_grade: "",
        saved_job_grade: []
      },
      selected: {
        id: "",
        name: "",
        jd: "",
        jd_form: "",
        desc: "",
        g_status_id: ""
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    },

    "job_grade_tab.picked_job_grade"(val) {
      if (val !="") {
        var temp = this.job_grade_tab.saved_job_grade.find(item => {
          return item.job_grade_id == val.id;
        });

        if (!temp) {
          // add job grade here
          var option = {
            id: "",
            position_id: this.selected.id,
            job_grade_id: val.id
          };

          this.update_job_grade(option);
        }
        this.job_grade_tab.picked_job_grade = "";
      }
    }
  },
  async mounted() {
    // NOTE: check user role to allow records EDIT.
    this.username = auth.getUsername();

    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
      res = res.data;
      if (res.Status == 1) {
        this.roles.roles_list = res.Body;
      } else {
        common.wMsgBox.Error(res.Description);
      }
    
    this.roles.auth_role = common.App.check_role(this.roles.roles_list, 9);

    // NOTE: call status from general options.
    this.status_option = await common.App.getGeneralOptions(
      "General",
      "status",
      ["id", "value"]
    );

    let cls_qb = new qb.QueryBuilder();

    cls_qb.Method = "all";
    cls_qb.Table = "emps_job_grade";

    cls_qb.Select = ["id", "desc"];

    var rule = new qb.Rule();
    rule
      .field("g_status_id")
      .operator(qb.NUM_OPERATOR.EQUAL)
      .value(4);
    cls_qb.addRule(rule);

    cls_qb.Order = ["desc"];

    let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

    if (result.data.Status == 1) {
      this.dialog.job_grade_list = result.data.Body.records;
    } else {
      common.wMsgBox.Error(result.data.Description);
    }

    // NOTE: call for form list with form_id.
    var forms = await comm.getFormData(
      'for rec in forms filter contains(rec.name,"Form 47") and rec.status == 1 return {"form_id":rec._id, "form_name":rec.name}'
    );
    this.forms = forms.data;

    var self = this;
    function handleMessage(e) {
      if (e.data.event == "form_data_saved") {
        // common.wMsgBox.Success("Record successfully submitted.");
        self.dialog_viewForm.height = e.data.window.height;

        //common.wMsgBox.Success("Record sucessfully updated.");
        // common.wMsgBox.Success(JSON.stringify(e));
      }
      if (e.data.event == "form_loaded") {
        self.dialog_viewForm.height = e.data.window.height + 350;
      }
    }

    window.addEventListener("message", handleMessage, false);

  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    async refreshData() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";
      cls_qb.Table = "emps_position";

      cls_qb.Select = [
        "id",
        "name",
        "g_status_id",
        "g_status__value",
        "jd",
        "jd_form",
        "created_date",
        "desc"
      ];

      cls_qb.Where = this.new_filter;

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;

        this.dialog.parent_company_list = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async editRecord_onClick(item) {
      this.dialog.visible = true;
      this.dialog.title = "Modifying ";

      this.$validator.reset();

      this.selected = {
        id: item["id"],
        name: item["name"],
        jd: item["jd"],
        jd_form: item["jd_form"],
        desc: item["desc"],
        g_status_id: item["g_status_id"]
      };

      // call for job grade set.
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";
      cls_qb.Table = "emps_jg_position";

      cls_qb.Select = [
        "id",
        "job_grade_id",
        "job_grade__desc"
      ];

      var rule = new qb.Rule();
      rule
        .field("position_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(item["id"]);
      cls_qb.addRule(rule);

      cls_qb.Order = ["job_grade__desc"];

      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        this.job_grade_tab.saved_job_grade = await result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    addNewRecord_onClick() {
      this.dialog.visible = true;
      this.dialog.title = "Create";

      this.$validator.reset();

      this.selected = {
        id: "",
        name: "",
        jd: "",
        jd_form: "",
        desc: "",
        g_status_id: this.status_option[0].id
      };
    },
    save_onClick() {
      let self = this;

      this.$validator.validateAll().then(async result => {
        if (result) {
          let result = await common.wBackEndComm.PostData(
            "position/crud_position/",
            self.selected
          );

          if (result.data.Status == 1) {
            self.dialog.visible = false;
            self.refreshData();
            common.wMsgBox.Success(result.data.Description);
          } else {
            common.wMsgBox.Error(result.data.Description);
          }
        }
      });
    },
    async update_job_grade(option) {
      var self = this;
      let result = await common.wBackEndComm.PostData(
        "position/update_jg/",
        option
      );
      
      if (result.data.Status == 1) {
        self.refresh_job_grade(self.selected.id);
        common.wMsgBox.Success(result.data.Description);
        
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refresh_job_grade(position_id) {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";
      cls_qb.Table = "emps_jg_position";

      cls_qb.Select = [
        "id",
        "job_grade_id",
        "job_grade__desc"
      ];

      var rule = new qb.Rule();
      rule
        .field("position_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(position_id);
      cls_qb.addRule(rule);

      cls_qb.Order = ["job_grade__desc"];

      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        this.job_grade_tab.saved_job_grade = await result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async delete_job_grade(item) {
      var option = item;

      await this.update_job_grade(option);
    },

    viewForm_onClick(form_name) {
      
      // console.log(form_name);
      // console.log(this.forms);
      this.dialog_viewForm.visible = true;
      var formList = this.forms;
      
      for (var i in formList) {
        if (formList[i].form_name == form_name) {
          var view_form_id = formList[i].form_id;
        }
      }
      this.dialog_viewForm.iframe_url = comm.form_ip + view_form_id + "&readOnly=true";
      // console.log(url);
    }
  }
};
</script>

<style scoped>
.tab-style {
  height: 350px;
  margin-top: 5px;
}
</style>
